<template>
    <Layout>
      <div class="row">
        <div class="col-12">
                <div class="row">
                  <div class="col-md-3">
                    <div class="card">
                    <div class="card-header bg-primary rounded-1 text-white">{{ service }}</div>
                    <div class="card-body p-2">
                      <div class=" mb-2 d-flex justify-content-between">
                        <img class="img-rounded" src="@/assets/images/sick.png" height="70px" />
                        <span><a @click="$router.go(-1)" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-undo"></i> back</a></span>
                      </div>
                      <span v-if="patientspinner==false">
                      <table v-for="item in patients" :key="item.id" class="table">
                      <tr><td>Full Name </td><td> <b class="text-primary h7">{{ item.name }} </b></td></tr>
                      <tr><td>Gender </td><td> <span class="text-primary h7">{{ item.gender }} </span></td></tr>
                      <tr><td> Telephone </td><td> <span class="text-primary h7">0{{ item.telephone }} </span></td></tr>
                      <tr><td> Age </td><td> <span class="text-primary h7">{{ getAge(item.date_of_birth) }} yrs </span></td></tr>
                      <tr><td> Address </td><td> <span class="text-primary h7">{{ item.address }} </span></td></tr>
                      <tr><td> Nationality </td><td> <span class="text-primary h7">{{ item.nationality }} </span></td></tr>
                      </table>
                      <h5 class="my-3"><i class="mdi mdi-calendar"></i> &nbsp;&nbsp; {{ visit_date }}</h5>

                      </span>
                      <span v-else>
                        <i class="fas fa-spinner fa-3x p-5 text-primary fa-spin"></i> 
                      </span>
                    </div>
                    </div>
                  </div>
                  <div class="col-md-9">
                    <b-tabs pills nav-class="p-0" content-class="text-dark">
                      <b-tab active class="border-0">
                        <template v-slot:title>Outcome of Labour</template>
                        <div class="card">
                          <div class="card-body">
                            <span v-if="partogram==''">
                            <form @submit.prevent="addPartogram">
                            <div class="row gy-2 gx-2 align-items-center">
                            <div class="col-auto">
                                <label>Upload Partogram</label>
                                <input type="file" class="form-control" v-on:change="onFileChange">
                            </div>
                            <div class="col-auto">
                                <b-button variant="primary" type="submit" class="w-md mt-4">Upload</b-button>
                            </div>
                            </div>
                            </form>
                            </span>
                            <span v-else>
                            <div v-for="item in partogram" :key="item.id">
                                <i class="mdi mdi-file-outline text-primary h1"></i> &nbsp; &nbsp;
                                <span class="h5 text-primary">Partogram</span>&nbsp; &nbsp;
                                <a :href="getFiles(item.chart_label)" download="" class="btn btn-sm btn-primary"> <i class="mdi mdi-download"></i> </a>&nbsp; &nbsp;
                                <a target="_blank" :href="getFiles(item.chart_label)" class="btn btn-sm btn-danger"> <i class="mdi mdi-eye"></i> </a>
                            </div>
                            </span>
                            <hr>
                              <form @submit.prevent="addTreatment">
                                <b>Outcome of Labour</b>
                                <div class="row">
                                    <div class="form-group col-4">
                                        <span>Date of delivery</span>
                                        <b-form-input v-model="labourdate" type="date" size="sm"></b-form-input>
                                    </div>
                                    <div class="form-group col-4">
                                        <span>Time</span>
                                        <b-form-input v-model="labourtime" type="time" size="sm"></b-form-input>
                                    </div>
                                    <div class="form-group col-4">
                                        <span>Type of delivery</span>
                                        <b-form-input v-model="typeofdelivery" type="text" size="sm"></b-form-input>
                                    </div>
                                </div>

                                <div class="row mt-2">
                                    <div class="form-group col-6">
                                        <span>Duration of 1st Stage</span>
                                        <b-form-input v-model="durationof1stage" type="text" size="sm"></b-form-input>
                                    </div>
                                    <div class="form-group col-6">
                                        <span>Duration of 2nd Stage</span>
                                        <b-form-input v-model="durationof2stage" type="text" size="sm"></b-form-input>
                                    </div>
                                </div>

                                <div class="row mt-2">
                                    <div class="form-group col-4">
                                        <span>Post Delivery BP</span>
                                        <b-form-input v-model="postdeliverybp" type="text" size="sm"></b-form-input>
                                    </div>
                                    <div class="form-group col-4">
                                        <span>Post Delivery Pulse</span>
                                        <b-form-input v-model="postdeliverypulse" type="text" size="sm"></b-form-input>
                                    </div>
                                    <div class="form-group col-4">
                                        <span>Post Delivery Temp</span>
                                        <b-form-input v-model="postdeliverytemp" type="text" size="sm"></b-form-input>
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <div class="form-group col-5">
                                        <span class="">Time of delivery of Placenta and Membranes</span>
                                        <b-form-input v-model="placenta" type="text" size="sm"></b-form-input>
                                    </div>
                                    <div class="form-group col-7">
                                        <span>Oxytocic Given</span><br>
                                        <input class="form-check-input" :checked="pitocin" v-model="pitocin" type="checkbox" id="autoSizingCheck"/>
                                        <label class="mx-1"><small>Pitocin (10IU)</small></label>
                                        <input class="form-check-input" :checked="ergometrine" v-model="ergometrine" type="checkbox" id="autoSizingCheck"/>
                                        <label class="mx-1"><small>Ergometrine (0.4mg)</small></label>
                                        <input class="form-check-input" :checked="misoprostol" v-model="misoprostol" type="checkbox" id="autoSizingCheck"/>
                                        <label class="mx-1"> <small>Misoprostol(600micrograms)</small></label>
                                    </div>
                                </div>

                                <div class="row mt-2">
                                    <div class="form-group col-6">
                                        <span>Amount of Blood Loss</span>
                                        <b-form-input v-model="bloodloss" type="text" size="sm"></b-form-input>
                                    </div>
                                    <div class="form-group col-6">
                                        <span>Genital Tract/Perineum</span>
                                        <b-form-input v-model="perineum" type="text" size="sm"></b-form-input>
                                    </div>
                                </div>

                                <div class="row mt-2">
                                    <div class="form-group col-4">
                                        <span>Amount in mls</span>
                                        <b-form-input v-model="amountinmls" type="text" size="sm"></b-form-input>
                                    </div>
                                    <div class="form-group col-4">
                                        <span>Episiotomy</span>
                                        <b-form-input v-model="episiotomy" type="text" size="sm"></b-form-input>
                                    </div>
                                    <div class="form-group col-4">
                                        <span>Tears</span>
                                        <b-form-input v-model="tears" type="text" size="sm"></b-form-input>
                                    </div>
                                </div>

                                <b class="mt-2">Baby</b>
                                <div class="row">
                                    <div class="form-group col-4">
                                        <span>Alive <small>(YES/NO)</small></span>
                                        <b-form-input v-model="alive" type="text" size="sm"></b-form-input>
                                    </div>
                                    <div class="form-group col-4">
                                        <span>if 'NO', Cause of death</span>
                                        <b-form-input v-model="casueofdeath" type="text" size="sm"></b-form-input>
                                    </div>
                                    <div class="form-group col-4">
                                        <span>Still</span>
                                        <b-form-input v-model="still" type="text" size="sm"></b-form-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-group col-6">
                                        <span>Apgar score at <small>(1 min)</small></span>
                                        <b-form-input v-model="apgarscore1" type="text" size="sm"></b-form-input>
                                    </div>
                                    <div class="form-group col-6">
                                        <span>at <small>(5 mins) time of delivery</small></span>
                                        <b-form-input v-model="apgarscore5" type="text" size="sm"></b-form-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-group col-6">
                                        <span>Sex</span>
                                        <b-form-input v-model="sex" type="text" size="sm"></b-form-input>
                                    </div>
                                    <div class="form-group col-6">
                                        <span>Weight</span>
                                        <b-form-input v-model="weight" type="text" size="sm"></b-form-input>
                                    </div>
                                </div>

                                <b class="mt-2">Newborn Gestational age and condition</b>
                                <div class="row">
                                    <div class="form-group col-4">
                                        <span>Term <small>(YES/NO)</small></span>
                                        <b-form-input v-model="gestationalterm" type="text" size="sm"></b-form-input>
                                    </div>
                                    <div class="form-group col-4">
                                        <span>Preterm <small>(YES/NO)</small></span>
                                        <b-form-input v-model="preterm" type="text" size="sm"></b-form-input>
                                    </div>
                                    <div class="form-group col-4">
                                        <span>Post term <small>(YES/NO)</small></span>
                                        <b-form-input v-model="postterm" type="text" size="sm"></b-form-input>
                                    </div>
                                </div>

                                <b class="mt-2">Physical Abnormalities <small>(YES/NO)</small></b>
                                <div class="row">
                                    <div class="form-group col-6">
                                        <span>If 'Yes' <small>(Specify)</small></span>
                                        <b-form-input v-model="abnormalities" type="text" size="sm"></b-form-input>
                                    </div>
                                    <div class="form-group col-6">
                                        <span>Is the anus patent ? <small>(YES/NO)</small></span>
                                        <b-form-input v-model="anuspatent" type="text" size="sm"></b-form-input>
                                    </div>
                                </div>

                                <b class="mt-2">Birth Injury <small>(YES/NO)</small></b>
                                <div class="row">
                                    <div class="form-group ">
                                        <span>If 'Yes' <small>(Specify)</small></span>
                                        <b-form-input v-model="birthinjury" type="text" size="sm"></b-form-input>
                                    </div>
                                </div>

                                <b class="mt-2">Immediate Newborn Care given</b>
                                <div class="row">
                                    <div class="form-group col-6">
                                        <span>Cord Well ligated<small>(not bleeding) YES/NO</small></span>
                                        <b-form-input v-model="cord" type="text" size="sm"></b-form-input>
                                    </div>
                                    <div class="form-group col-6">
                                        <span>Baby kept Warm ? <small>(YES/NO)</small></span>
                                        <b-form-input v-model="keptwarm" type="text" size="sm"></b-form-input>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col-6">
                                        <span>Breastfeeding initiated within 1 hour<small>(YES/NO)</small></span>
                                        <b-form-input v-model="breastfeeding" type="text" size="sm"></b-form-input>
                                    </div>
                                    <div class="form-group col-6">
                                        <span>Tetracycline eye ointment given<small>(YES/NO)</small></span>
                                        <b-form-input v-model="tetracycline" type="text" size="sm"></b-form-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-group">
                                        <b>Vit K given<small>(YES/NO)</small></b>
                                        <b-form-input v-model="vitk" type="text" size="sm"></b-form-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-group col-6">
                                        <span>Immunisation<small>(BCG)</small></span>
                                        <b-form-input v-model="bcg" type="text" size="sm"></b-form-input>
                                    </div>
                                    <div class="form-group col-6">
                                        <span>Polio<small>(0)</small></span>
                                        <b-form-input v-model="polio" type="text" size="sm"></b-form-input>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <b>Specify ARVS given to baby (if applicable) according to guidelines</b>
                                    <b-form-input v-model="arvs" type="text" size="sm"></b-form-input>
                                </div>
                                <div class="form-group">
                                    <b>Are there signs and symptopms of infection?<small>(YES/NO)</small>, if YES Specify</b>
                                    <b-form-input v-model="infections" type="text" size="sm"></b-form-input>
                                </div>
                                <b class="mt-2">Immediate Postpartum Care (0-6 hrs) treatment given</b>
                                <div class="row">
                                    <div class="form-group col-6">
                                        <span>Given to the Baby</span>
                                        <textarea v-model="treatmenttobaby" rows="2" class="form-control"></textarea>
                                    </div>
                                    <div class="form-group col-6">
                                        <span>Given to the Mother</span>
                                        <textarea v-model="treatmenttomother" rows="2" class="form-control"></textarea>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col-6">
                                        <span>Delivered By</span>
                                        <b-form-input v-model="deliveryby" type="text" size="sm"></b-form-input>
                                    </div>
                                    <div class="form-group col-6">
                                        <span>Ward</span>
                                        <b-form-input v-model="ward" type="text" size="sm"></b-form-input>
                                    </div>
                                </div>
                                <div class="form-group d-flex justify-content-end mt-3">
                                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
                                </div>
                              </form>
                          </div>
                        </div>
                      </b-tab>
                      <b-tab class="border-0">
                          <template v-slot:title>Presciptions</template>
                          <div class="card">
                            <div class="card-body">
                              <b-button v-b-modal.new-prescription size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Prescription</b-button>
                              <table class="table table-sm mt-2" style="color: black;" density="compact">
                              <thead><tr><th>Medicine</th><th>Dosage</th><th>Note</th></tr></thead>
                              <tbody>
                                <tr v-for="item in prescriptions" :key="item.id">
                                    <td>{{ item.medicine.name }} </td>
                                    <td>{{ item.dosage }}</td>
                                    <td>{{ item.note }}</td>
                                </tr>
                              </tbody>
                              </table>
                            </div>
                          </div>
                      </b-tab>
                      <b-tab class="border-0">
                        <template v-slot:title>Services</template>
                        <div class="card">
                          <div class="card-body">
                              <b-button v-b-modal.new-service size="sm" variant="primary"><i class="mdi mdi-plus"></i> Add a Service</b-button>
                              <table class="table table-sm mt-2" style="color: black;" density="compact">
                              <thead><tr><th>Category</th><th>Service Name</th><th>Service Price</th><th>Status</th></tr></thead>
                              <tbody>
                                <tr v-for="item in services" :key="item.id">
                                    <td>{{ item.service_category.name }} </td>
                                    <td>{{ item.service_name.name }}</td>
                                    <td>{{ item.service_price }}</td>
                                    <td>
                                      <span v-if="item.status==1">
                                        <span class="btn btn-sm btn-dark">Pending</span>
                                      </span>
                                      <span v-else>
                                        <b-button @click="edit(item.service_name.id,item.service_name.name )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-clipboard-list"></i> results </b-button>
                                      </span>
                                    </td>
                                </tr>
                              </tbody>
                              </table>
                          </div>
                        </div>
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
        </div>
      </div>
      <b-modal id="new-service" size="md" title="New Service" title-class="font-14" hide-footer>
        <form @submit.prevent="AddPatientService">
          <div class="form-group mb-2">
            <label>Service Category</label> <small class="text-danger">*</small>
            <multiselect v-model="service_category" @input="FilterCategory" :options="servicecategories" label="name"></multiselect>
          </div>
          <div class="form-group mb-2">
            <label>Service Name</label> <small class="text-danger">*</small>
            <multiselect v-model="service_name" label="name" @input="FilterServicePrice" :options="newservices"></multiselect>
          </div>
          <div class="form-group mb-2">
            <label>Service Cost</label> <small class="text-danger">*</small>
            <input v-model="service_price" readonly required type="number" class="form-control" />
          </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-service')" >Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
        </div>
      </form>
      </b-modal>
  
      <b-modal id="new-prescription" centered title="New Prescription" title-class="font-18" hide-footer>
          <form @submit.prevent="addPrescription">
            <div class="form-group mb-2">
              <label>Medicine</label>
                <multiselect v-model="medicine" @input="FilterProductUnits" :options="products" label="name"></multiselect>
              </div>
              <div class="row">
              <div class="col-md-6">
              <label>Unit</label>
                <multiselect v-model="unit" @input="FilterPrice" :options="units" label="unit"></multiselect>
              </div>
              <div class="col-md-6">
              <label>Price</label>
                <input v-model="price" type="number" readonly class="form-control" />
              </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label>Dose</label>
                  <input v-model="dose" type="number"  @input="CheckMedicine" min="1" required class="form-control" />
                </div>
                <div class="col-4">
                  <label>Frequency</label>
                  <input v-model="frequency" type="number" @input="CheckMedicine" min="1" required class="form-control" />
                </div>
                <div class="col-4">
                  <label>Duration</label>
                  <input v-model="duration" type="number" @input="CheckMedicine" min="1" required class="form-control" />
                </div>
              </div>
              <div class="form-group mb-2">
              <label>Total Amount</label>
                <input v-model="totalprice" type="number" readonly class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>Prescription Note</label>
              <textarea v-model="note" rows="2" class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-prescription')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="view-results" centered :title="resultname" title-class="font-14" hide-footer>
          
        <span v-for="item in treatmentresults" :key="item.id">
          <div class="row">
            <div class="col-md-6">
              <span>Presented Complaints <span class="text-info h5" v-html="item.symptoms"></span></span>
              <span>History of Presented Complaints <span class="text-info h5" v-html="item.history"></span></span>
              <span>General Examination to Review of Systems <span class="text-info h5" v-html="item.examination"></span></span>
            </div>
            <div class="col-md-6" style="border-left: 1px solid grey;">
              <span>Provisional Diagnosis <span class="text-info h5" v-html="item.diagnosis"></span></span>
              <span>Recommendation <span class="text-info h5" v-html="item.recommedation"></span></span>
            </div>
          </div>
        </span>
  
      </b-modal>
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Layout from "../../layouts/main";
  import appConfig from "@/app.config";
  import Multiselect from "vue-multiselect";
  import { productMethods, productComputed , serviceCategoryMethods,serviceCategoryComputed} from "@/state/helpers";
  
  export default {
    page: {
      title: "Patient Treatment",
      meta: [{name: "description",content: appConfig.description,},],
    },
    components: {
      Layout,Multiselect,
    },
    data() {
      return {
        title: "Patient Treatment",
        items: [{text: "Dashboard",to: "/",},{text: "Patients",active: true,},],
        patients:[],
        patientsymptoms:[],
        patientdiseases:[],
        prescriptions:[],
        diagnosis:[],
        symptoms:[],
        services:[],
        newservices:[],
        patientspinner:true,
        patientid:'',
        visitid:'',
        service:'',
        service_id:'',
        recommedation:'',
        examination:'',
        history:'',
        medicine:'',
        price:'',
        quantity:'',
        dose:'1',
        frequency:'1',
        duration:'1',
        note:'',
        units:[],
        unit:'',
        totalprice:'',
        service_category:[],
        service_name:[],
        service_price:'',
        patient_type:'1',
        resultid:'',
        resultname:'',
        treatmentresults:[],
        files:'',
        partogram:[],
        labourdate:new Date().toLocaleDateString('fr-CA'),
        labourtime:'',
        typeofdelivery:'',
        postdeliverybp:'',
        postdeliverypulse:'',
        postdeliverytemp:'',
        durationof1stage:'',
        durationof2stage:'',
        placenta:'',
        pitocin:'',
        ergometrine:'',
        misoprostol:'',
        bloodloss:'',
        perineum:'',
        amountinmls:'',
        episiotomy:'',
        tears:'',
        alive:'',
        casueofdeath:'',
        still:'',
        apgarscore1:'',
        apgarscore5:'',
        sex:'',
        weight:'',
        gestationalterm:'',
        preterm:'',
        postterm:'',
        abnormalities:'',
        anuspatent:'',
        birthinjury:'',
        cord:'',
        keptwarm:'',
        breastfeeding:'',
        tetracycline:'',
        vitk:'',
        bcg:'',
        polio:'',
        arvs:'',
        infections:'',
        deliveryby:'',
        ward:'',
        treatmenttobaby:'',
        treatmenttomother:'',
        visit_date:'',
      };
    },
    computed: {
        ...productComputed,
        ...serviceCategoryComputed,
    },
    created() {
      this.fetchServiceCategory();
      this.fetchProducts();
      this.fetchInfo();
    },
    methods: {
      ...productMethods,
      ...serviceCategoryMethods,
      getAge(dateString){
      let birth = new Date(dateString); let now = new Date(); let beforeBirth = ((() => {birth.setDate(now.getDate());birth.setMonth(now.getMonth()); return birth.getTime()})() < birth.getTime()) ? 0 : 1;
      return now.getFullYear() - birth.getFullYear() - beforeBirth;
    },
      onFileChange(e){
        this.files = e.target.files[0];
      },
      getFiles(name){
        let url = axios.defaults.baseURL;
        let imagelink = (url).slice(0,-3)+"partograms/"+name;
        return imagelink;
      },
      async edit(id,name){
        this.resultid=id;
        this.resultname=name;
        let url = `/profiletreatment/${this.patientid},${this.visitid},${this.resultid}`;
        await axios.get(url).then((response) => {
          this.treatmentresults = response.data.treatments;
        });
        this.$bvModal.show('view-results')
      },
      async fetchInfo(){
        this.id=this.$route.query.id;
        let url = `/visitinfo/${this.id}`;
        await axios.get(url).then((response) => {
          this.patientid = response.data.visits[0].patient.patient_id;
          this.visitid = response.data.visits[0].visit_id;
          this.service = response.data.visits[0].service_name.name;
          this.service_id = response.data.visits[0].service_name.id;
          this.visit_date = response.data.visits[0].addedon;
          this.showpatient();
          this.showtprescriptions();
          this.showtreatments();
          this.showservices();
          this.showPartogram();
        });
      },
      async FilterCategory(){
        let url = `/servicebycategory/${this.service_category.id}`;
          await axios.get(url).then((response) => {
            this.newservices = response.data.services;
          });
      },
      async FilterServicePrice(){
          let url = `/serviceprice/${this.service_name.id}`;
          await axios.get(url).then((response) => {
            this.service_price = response.data.price;
            });
        },
      CheckMedicine(){
        this.totalprice = this.price*this.dose*this.frequency*this.duration;
      },
      async FilterProductUnits(){
          let url = `/unitsbyproduct/${this.medicine.id}`;
          await axios.get(url).then((response) => {
            this.units = response.data.units;
            });
        },
        async FilterPrice(){
          let url = `/productbyunitprice/${this.unit.unit_id},${this.medicine.id}`;
          await axios.get(url).then((response) => {
            this.price = response.data.price;
            this.CheckMedicine();
            });
        },
      async showpatient(){
        let url = `/patientprofile/${this.patientid}`;
        await axios.get(url).then((response) => {
          this.patients = response.data.patients;
          this.patientspinner=false;
        });
      },
      async showservices(){
        let url = `/profileservices/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.services = response.data.visits;
        });
      },
      async showPartogram(){
        let url = `/partogram/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.partogram = response.data.chart;
        });
      },
      async showtprescriptions(){
        let url = `/profileprescription/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.prescriptions = response.data.prescriptions;
        });
      },
      async showtreatments(){
        let url = `/labouroutcomes/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
        if (response.data.outcome.length>0) {
          this.labourdate = response.data.outcome[0].labourdate;
          this.labourtime = response.data.outcome[0].labourtime;
          this.typeofdelivery = response.data.outcome[0].typeofdelivery;
          this.postdeliverybp = response.data.outcome[0].postdeliverybp;
          this.postdeliverypulse = response.data.outcome[0].postdeliverypulse;
          this.postdeliverytemp = response.data.outcome[0].postdeliverytemp;
          this.durationof1stage = response.data.outcome[0].durationof1stage;
          this.durationof2stage = response.data.outcome[0].durationof2stage;
          this.placenta = response.data.outcome[0].placenta;
          this.bloodloss = response.data.outcome[0].bloodloss;
          this.pitocin = response.data.outcome[0].pitocin;
          this.ergometrine = response.data.outcome[0].ergometrine;
          this.misoprostol = response.data.outcome[0].misoprostol;
          this.perineum = response.data.outcome[0].perineum;
          this.amountinmls = response.data.outcome[0].amountinmls;
          this.episiotomy = response.data.outcome[0].episiotomy;
          this.tears = response.data.outcome[0].tears;
          this.alive = response.data.outcome[0].alive;
          this.casueofdeath = response.data.outcome[0].casueofdeath;
          this.still = response.data.outcome[0].still;
          this.apgarscore1 = response.data.outcome[0].apgarscore1;
          this.apgarscore5 = response.data.outcome[0].apgarscore5;
          this.sex = response.data.outcome[0].sex;
          this.weight = response.data.outcome[0].weight;
          this.gestationalterm = response.data.outcome[0].gestationalterm;
          this.preterm = response.data.outcome[0].preterm;
          this.postterm = response.data.outcome[0].postterm;
          this.abnormalities = response.data.outcome[0].abnormalities;
          this.anuspatent = response.data.outcome[0].anuspatent;
          this.birthinjury = response.data.outcome[0].birthinjury;
          this.cord = response.data.outcome[0].cord;
          this.keptwarm = response.data.outcome[0].keptwarm;
          this.breastfeeding = response.data.outcome[0].breastfeeding;
          this.tetracycline = response.data.outcome[0].tetracycline;
          this.vitk = response.data.outcome[0].vitk;
          this.bcg = response.data.outcome[0].bcg;
          this.polio = response.data.outcome[0].polio;
          this.arvs = response.data.outcome[0].arvs;
          this.infections = response.data.outcome[0].infections;
          this.deliveryby = response.data.outcome[0].deliveryby;
          this.ward = response.data.outcome[0].ward;
          this.treatmenttobaby = response.data.outcome[0].treatmenttobaby;
          this.treatmenttomother = response.data.outcome[0].treatmenttomother;
        }
        });
      },
      async addPartogram(){
        let formData = new FormData();
          formData.append("patient_id", this.patientid);
          formData.append("visit_id", this.visitid);
          formData.append("file", this.files);
          let url = "/addpartogram";
          await axios.post(url, formData).then((response) => {
          if (response.status == 200) {
              this.showPartogram();
              this.files="";
              this.$toast.success(response.message);
          }
          });
      },
      async AddPatientService() { 
          let formData = new FormData();
          formData.append("patient_id", this.patientid);
          formData.append("visit_id", this.visitid);
          formData.append("service_category", this.service_category.id);
          formData.append("service_name", this.service_name.id);
          formData.append("service_price", this.service_price);
          let url = "/addpatientvisit";
          await axios.post(url, formData).then((response) => {
          if (response.status == 200) {
              this.showservices();
              this.$bvModal.hide('new-service');
              this.service_category="";
              this.service_name="";
              this.service_price="";
              this.$toast.success("New Patient Service Added");
          }
          });
        },
      async addTreatment() { 
        let formData = new FormData();
        formData.append("patient_id", this.patientid);
        formData.append("visit_id", this.visitid);
        formData.append("labourdate", this.labourdate);
        formData.append("labourtime", this.labourtime);
        formData.append("typeofdelivery", this.typeofdelivery);
        formData.append("postdeliverybp", this.postdeliverybp);
        formData.append("postdeliverypulse", this.postdeliverypulse);
        formData.append("postdeliverytemp", this.postdeliverytemp);
        formData.append("durationof1stage", this.durationof1stage);
        formData.append("durationof2stage", this.durationof2stage);
        formData.append("placenta", this.placenta);
        formData.append("pitocin", this.pitocin);
        formData.append("ergometrine", this.ergometrine);
        formData.append("misoprostol", this.misoprostol);
        formData.append("bloodloss", this.bloodloss);
        formData.append("perineum", this.perineum);
        formData.append("amountinmls", this.amountinmls);
        formData.append("episiotomy", this.episiotomy);
        formData.append("tears", this.tears);
        formData.append("alive", this.alive);
        formData.append("casueofdeath", this.casueofdeath);
        formData.append("still", this.still);
        formData.append("apgarscore1", this.apgarscore1);
        formData.append("apgarscore5", this.apgarscore5);
        formData.append("sex", this.sex);
        formData.append("weight", this.weight);
        formData.append("still", this.still);
        formData.append("gestationalterm", this.gestationalterm);
        formData.append("preterm", this.preterm);
        formData.append("postterm", this.postterm);
        formData.append("abnormalities", this.abnormalities);
        formData.append("anuspatent", this.anuspatent);
        formData.append("birthinjury", this.birthinjury);
        formData.append("cord", this.cord);
        formData.append("keptwarm", this.keptwarm);
        formData.append("breastfeeding", this.breastfeeding);
        formData.append("tetracycline", this.tetracycline);
        formData.append("vitk", this.vitk);
        formData.append("bcg", this.bcg);
        formData.append("polio", this.polio);
        formData.append("arvs", this.arvs);
        formData.append("infections", this.infections);
        formData.append("treatmenttobaby", this.treatmenttobaby);
        formData.append("treatmenttomother", this.treatmenttomother);
        formData.append("deliveryby", this.deliveryby);
        formData.append("ward", this.ward);
        let url = "/addlabouroutcomes";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.showtreatments();
            this.$toast.success("Patient Treatment Added");
        }
        });
      },
      async addPrescription() {
        let formData = new FormData();
        formData.append("patient_id", this.patientid);
        formData.append("visit_id", this.visitid);
        formData.append("service_id", this.service_id);
        formData.append("medicine", this.medicine.id);
        formData.append("unit", this.unit.unit_id);
        formData.append("dosage", this.dose+" * "+this.frequency+" * "+this.duration );
        formData.append("quantity", this.dose*this.frequency*this.duration );
        formData.append("totalprice", this.totalprice);
        formData.append("note", this.note);
        let url = "/addprescription";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.$bvModal.hide('new-prescription');
            this.showtprescriptions();
            this.medicine="";
            this.dose="";
            this.frequency="";
            this.duration="";
            this.note="";
            this.$toast.success("Patient Prescription Added");
        }
        });
      },
    },
  };
  </script>